import { BehaviorSubject } from 'rxjs';
/**
 * @description This behavior subject is meant to only by used inside the m365-apps-config.service inside OfficeHome until the entirety of
 * the m365 apps service is migrated to this package.
 *
 * @deprecated To consume HarmonyAppDefinitions inside your React component, please use the hook provided, useAppDefinitions.
 */
export var m365AppDefinitionsBehaviorSubject = new BehaviorSubject([]);
//# sourceMappingURL=m365AppsBehaviorSubject.js.map